import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=78b534a4&scoped=true"
import script from "./Identity.vue?vue&type=script&lang=js"
export * from "./Identity.vue?vue&type=script&lang=js"
import style0 from "./Identity.vue?vue&type=style&index=0&id=78b534a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b534a4",
  null
  
)

export default component.exports